import React, { useState } from "react";
import styled from "styled-components";
import { Button, Input, LoaderSpinner2 } from "../../../../components";
import { useDispatch } from "react-redux";
import { addPropertyRowToTable } from "../../../../store/reducers/products/tables/tables.actions";

export function AddMultipleRowsButton({
  ruletableData,
}: {
  ruletableData: any;
}) {
  const [inputValue, setInputValue] = useState<number | undefined>(undefined);
  const [isAdding, setIsAdding] = useState(false);

  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    if (e.target.value === "") {
      setInputValue(undefined);
      return;
    }
    setInputValue(parseInt(e.target.value.replace(/\D/, "")));
  };

  const handleSubmit = async () => {
    if (!inputValue || isAdding) return;

    const amount = inputValue > 30 ? 30 : inputValue;
    setIsAdding(true);
    try {
      await dispatch(addPropertyRowToTable(ruletableData, amount) as any);
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <Wrapper>
      <StyledButton
        size={"small"}
        onClick={handleSubmit}
        disabled={!inputValue || isAdding}
      >
        Add multiple rows
      </StyledButton>
      <StyledInput onChange={handleInputChange} value={inputValue} />
      {/* Fixed-size slot so spinner vs "max. 30" does not shift layout. */}
      <StatusSlot aria-live="polite">
        {isAdding ? <LoaderSpinner2 /> : <InfoWrapper>max. 30</InfoWrapper>}
      </StatusSlot>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const StyledButton = styled(Button)<any>``;

const StatusSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  min-height: 40px;
`;

const InfoWrapper = styled.div`
  font-size: 10px;
  color: slategrey;
`;

const StyledInput = styled(Input)<any>`
  width: 50px;
  height: 32px;
  padding: 6px 5px;
  font-size: 12px;
`;
